module.exports = __webpack_public_path__ + "static/media/chargext-2.8be64c92.jpg";